var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Black Solid Line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 0.7,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D100-Main-Room-Selection",
    transform: "translate(-214.000000, -51.000000)",
    fill: "#D8D8D8",
    stroke: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Menu-New-Menu-Main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-Menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(21.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(193.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(10.500000, 10.500000) scale(-1, 1) rotate(315.000000) translate(-10.500000, -10.500000) ",
    x: 10.5,
    y: -2.5,
    width: 1,
    height: 26
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSolid);
export default __webpack_public_path__ + "static/media/blackSolid.f7375280c431588b3eddab849936555e.svg";
export { ForwardRef as ReactComponent };